// extracted by mini-css-extract-plugin
export default {"info-box":"gXdEykuO9I5bj0Jl8T6FGA=="};